module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "tooth-wrap"
  }, [(!_vm.isShow) ? _c('div', {
    staticClass: "radio-wrap",
    on: {
      "change": _vm.changeBridge
    }
  }, [(_vm.servBridge && _vm.subCatalogId != '1010510') ? _c('el-radio', {
    attrs: {
      "label": false
    },
    model: {
      value: (_vm.isBridge),
      callback: function($$v) {
        _vm.isBridge = $$v
      },
      expression: "isBridge"
    }
  }, [_vm._v("单冠")]) : _vm._e(), _vm._v(" "), (_vm.servBridge) ? _c('el-radio', {
    attrs: {
      "label": true
    },
    model: {
      value: (_vm.isBridge),
      callback: function($$v) {
        _vm.isBridge = $$v
      },
      expression: "isBridge"
    }
  }, [_vm._v("连桥")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('table', {
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('tbody', [_c('tr', [_c('td'), _vm._v(" "), _c('div', [(_vm.metalPlatForm.includes(18)) ? _c('div', {
    ref: "018",
    class: _vm.metalPlatForm.includes(18) ? 'bridge-col-add' : 'bridge-col-zero',
    staticStyle: {
      "float": "left",
      "width": "6.75%"
    }
  }, [_c('i', {
    staticClass: "el-icon-s-help lab-cen"
  })]) : _c('div', {
    ref: "018",
    class: _vm.metalPlatForm2.includes(18) ? 'bridge-col-add' : 'bridge-col-zero',
    staticStyle: {
      "float": "left",
      "width": "6.75%"
    }
  }, [_c('i', {
    staticClass: "el-icon-s-help lab-cen porcelain"
  })]), _vm._v(" "), (_vm.metalPlatForm.includes(17)) ? _c('div', {
    ref: "017",
    class: _vm.metalPlatForm.includes(17) ? 'bridge-col-add' : 'bridge-col-zero',
    staticStyle: {
      "height": "2px",
      "float": "left",
      "width": "6.5%"
    }
  }, [_c('i', {
    staticClass: "el-icon-s-help lab-cen"
  })]) : _c('div', {
    ref: "017",
    class: _vm.metalPlatForm2.includes(17) ? 'bridge-col-add' : 'bridge-col-zero',
    staticStyle: {
      "height": "2px",
      "float": "left",
      "width": "6.5%"
    }
  }, [_c('i', {
    staticClass: "el-icon-s-help lab-cen porcelain"
  })]), _vm._v(" "), (_vm.metalPlatForm.includes(16)) ? _c('div', {
    ref: "016",
    class: _vm.metalPlatForm.includes(16) ? 'bridge-col-add' : 'bridge-col-zero',
    staticStyle: {
      "height": "2px",
      "float": "left",
      "width": "7.65%"
    }
  }, [_c('i', {
    staticClass: "el-icon-s-help lab-cen"
  })]) : _c('div', {
    ref: "016",
    class: _vm.metalPlatForm2.includes(16) ? 'bridge-col-add' : 'bridge-col-zero',
    staticStyle: {
      "height": "2px",
      "float": "left",
      "width": "7.65%"
    }
  }, [_c('i', {
    staticClass: "el-icon-s-help lab-cen porcelain"
  })]), _vm._v(" "), (_vm.metalPlatForm.includes(15)) ? _c('div', {
    ref: "015",
    class: _vm.metalPlatForm.includes(15) ? 'bridge-col-add' : 'bridge-col-zero',
    staticStyle: {
      "height": "2px",
      "float": "left",
      "width": "5.5%"
    }
  }, [_c('i', {
    staticClass: "el-icon-s-help lab-cen"
  })]) : _c('div', {
    ref: "015",
    class: _vm.metalPlatForm2.includes(15) ? 'bridge-col-add' : 'bridge-col-zero',
    staticStyle: {
      "height": "2px",
      "float": "left",
      "width": "5.5%"
    }
  }, [_c('i', {
    staticClass: "el-icon-s-help lab-cen porcelain"
  })]), _vm._v(" "), (_vm.metalPlatForm.includes(14)) ? _c('div', {
    ref: "014",
    class: _vm.metalPlatForm.includes(14) ? 'bridge-col-add' : 'bridge-col-zero',
    staticStyle: {
      "height": "2px",
      "float": "left",
      "width": "5.25%"
    }
  }, [_c('i', {
    staticClass: "el-icon-s-help lab-cen"
  })]) : _c('div', {
    ref: "014",
    class: _vm.metalPlatForm2.includes(14) ? 'bridge-col-add' : 'bridge-col-zero',
    staticStyle: {
      "height": "2px",
      "float": "left",
      "width": "5.25%"
    }
  }, [_c('i', {
    staticClass: "el-icon-s-help lab-cen porcelain"
  })]), _vm._v(" "), (_vm.metalPlatForm.includes(13)) ? _c('div', {
    ref: "013",
    class: _vm.metalPlatForm.includes(13) ? 'bridge-col-add' : 'bridge-col-zero',
    staticStyle: {
      "height": "2px",
      "float": "left",
      "width": "6.25%"
    }
  }, [_c('i', {
    staticClass: "el-icon-s-help lab-cen"
  })]) : _c('div', {
    ref: "013",
    class: _vm.metalPlatForm2.includes(13) ? 'bridge-col-add' : 'bridge-col-zero',
    staticStyle: {
      "height": "2px",
      "float": "left",
      "width": "6.25%"
    }
  }, [_c('i', {
    staticClass: "el-icon-s-help lab-cen porcelain"
  })]), _vm._v(" "), (_vm.metalPlatForm.includes(12)) ? _c('div', {
    ref: "012",
    class: _vm.metalPlatForm.includes(12) ? 'bridge-col-add' : 'bridge-col-zero',
    staticStyle: {
      "height": "2px",
      "float": "left",
      "width": "5%"
    }
  }, [_c('i', {
    staticClass: "el-icon-s-help lab-cen"
  })]) : _c('div', {
    ref: "012",
    class: _vm.metalPlatForm2.includes(12) ? 'bridge-col-add' : 'bridge-col-zero',
    staticStyle: {
      "height": "2px",
      "float": "left",
      "width": "5%"
    }
  }, [_c('i', {
    staticClass: "el-icon-s-help lab-cen porcelain"
  })]), _vm._v(" "), (_vm.metalPlatForm.includes(11)) ? _c('div', {
    ref: "011",
    class: _vm.metalPlatForm.includes(11) ? 'bridge-col-add' : 'bridge-col-zero',
    staticStyle: {
      "height": "2px",
      "float": "left",
      "width": "7%"
    }
  }, [_c('i', {
    staticClass: "el-icon-s-help lab-cen"
  })]) : _c('div', {
    ref: "011",
    class: _vm.metalPlatForm2.includes(11) ? 'bridge-col-add' : 'bridge-col-zero',
    staticStyle: {
      "height": "2px",
      "float": "left",
      "width": "7%"
    }
  }, [_c('i', {
    staticClass: "el-icon-s-help lab-cen porcelain"
  })]), _vm._v(" "), (_vm.metalPlatForm.includes(21)) ? _c('div', {
    ref: "021",
    class: _vm.metalPlatForm.includes(21) ? 'bridge-col-add' : 'bridge-col-zero',
    staticStyle: {
      "height": "2px",
      "float": "left",
      "width": "7.5%"
    }
  }, [_c('i', {
    staticClass: "el-icon-s-help lab-cen",
    staticStyle: {
      "margin-left": "40%"
    }
  })]) : _c('div', {
    ref: "021",
    class: _vm.metalPlatForm2.includes(21) ? 'bridge-col-add' : 'bridge-col-zero',
    staticStyle: {
      "height": "2px",
      "float": "left",
      "width": "7.5%"
    }
  }, [_c('i', {
    staticClass: "el-icon-s-help lab-cen porcelain",
    staticStyle: {
      "margin-left": "40%"
    }
  })]), _vm._v(" "), (_vm.metalPlatForm.includes(22)) ? _c('div', {
    ref: "022",
    class: _vm.metalPlatForm.includes(22) ? 'bridge-col-add' : 'bridge-col-zero',
    staticStyle: {
      "height": "2px",
      "float": "left",
      "width": "4.75%"
    }
  }, [_c('i', {
    staticClass: "el-icon-s-help lab-cen"
  })]) : _c('div', {
    ref: "022",
    class: _vm.metalPlatForm2.includes(22) ? 'bridge-col-add' : 'bridge-col-zero',
    staticStyle: {
      "height": "2px",
      "float": "left",
      "width": "4.75%"
    }
  }, [_c('i', {
    staticClass: "el-icon-s-help lab-cen porcelain"
  })]), _vm._v(" "), (_vm.metalPlatForm.includes(23)) ? _c('div', {
    ref: "023",
    class: _vm.metalPlatForm.includes(23) ? 'bridge-col-add' : 'bridge-col-zero',
    staticStyle: {
      "height": "2px",
      "float": "left",
      "width": "6.25%"
    }
  }, [_c('i', {
    staticClass: "el-icon-s-help lab-cen"
  })]) : _c('div', {
    ref: "023",
    class: _vm.metalPlatForm2.includes(23) ? 'bridge-col-add' : 'bridge-col-zero',
    staticStyle: {
      "height": "2px",
      "float": "left",
      "width": "6.25%"
    }
  }, [_c('i', {
    staticClass: "el-icon-s-help lab-cen porcelain"
  })]), _vm._v(" "), (_vm.metalPlatForm.includes(24)) ? _c('div', {
    ref: "024",
    class: _vm.metalPlatForm.includes(24) ? 'bridge-col-add' : 'bridge-col-zero',
    staticStyle: {
      "height": "2px",
      "float": "left",
      "width": "5.5%"
    }
  }, [_c('i', {
    staticClass: "el-icon-s-help lab-cen"
  })]) : _c('div', {
    ref: "024",
    class: _vm.metalPlatForm2.includes(24) ? 'bridge-col-add' : 'bridge-col-zero',
    staticStyle: {
      "height": "2px",
      "float": "left",
      "width": "5.5%"
    }
  }, [_c('i', {
    staticClass: "el-icon-s-help lab-cen porcelain"
  })]), _vm._v(" "), (_vm.metalPlatForm.includes(25)) ? _c('div', {
    ref: "025",
    class: _vm.metalPlatForm.includes(25) ? 'bridge-col-add' : 'bridge-col-zero',
    staticStyle: {
      "height": "2px",
      "float": "left",
      "width": "5.25%"
    }
  }, [_c('i', {
    staticClass: "el-icon-s-help lab-cen"
  })]) : _c('div', {
    ref: "025",
    class: _vm.metalPlatForm2.includes(25) ? 'bridge-col-add' : 'bridge-col-zero',
    staticStyle: {
      "height": "2px",
      "float": "left",
      "width": "5.25%"
    }
  }, [_c('i', {
    staticClass: "el-icon-s-help lab-cen porcelain"
  })]), _vm._v(" "), (_vm.metalPlatForm.includes(26)) ? _c('div', {
    ref: "026",
    class: _vm.metalPlatForm.includes(26) ? 'bridge-col-add' : 'bridge-col-zero',
    staticStyle: {
      "height": "2px",
      "float": "left",
      "width": "7.5%"
    }
  }, [_c('i', {
    staticClass: "el-icon-s-help lab-cen"
  })]) : _c('div', {
    ref: "026",
    class: _vm.metalPlatForm2.includes(26) ? 'bridge-col-add' : 'bridge-col-zero',
    staticStyle: {
      "height": "2px",
      "float": "left",
      "width": "7.5%"
    }
  }, [_c('i', {
    staticClass: "el-icon-s-help lab-cen porcelain"
  })]), _vm._v(" "), (_vm.metalPlatForm.includes(27)) ? _c('div', {
    ref: "027",
    class: _vm.metalPlatForm.includes(27) ? 'bridge-col-add' : 'bridge-col-zero',
    staticStyle: {
      "height": "2px",
      "float": "left",
      "width": "7%"
    }
  }, [_c('i', {
    staticClass: "el-icon-s-help lab-cen"
  })]) : _c('div', {
    ref: "027",
    class: _vm.metalPlatForm2.includes(27) ? 'bridge-col-add' : 'bridge-col-zero',
    staticStyle: {
      "height": "2px",
      "float": "left",
      "width": "7%"
    }
  }, [_c('i', {
    staticClass: "el-icon-s-help lab-cen porcelain"
  })]), _vm._v(" "), (_vm.metalPlatForm.includes(28)) ? _c('div', {
    ref: "028",
    class: _vm.metalPlatForm.includes(28) ? 'bridge-col-add' : 'bridge-col-zero',
    staticStyle: {
      "height": "2px",
      "float": "left",
      "width": "6.25%"
    }
  }, [_c('i', {
    staticClass: "el-icon-s-help lab-cen"
  })]) : _c('div', {
    ref: "028",
    class: _vm.metalPlatForm2.includes(28) ? 'bridge-col-add' : 'bridge-col-zero',
    staticStyle: {
      "height": "2px",
      "float": "left",
      "width": "6.25%"
    }
  }, [_c('i', {
    staticClass: "el-icon-s-help lab-cen porcelain"
  })])]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('div', [_c('div', {
    ref: "018",
    class: _vm.bridgeList.includes(18) ? 'bridge-col' : '',
    staticStyle: {
      "height": "2px",
      "float": "left",
      "width": "6.75%"
    }
  }), _vm._v(" "), _c('div', {
    ref: "017",
    class: _vm.bridgeList.includes(17) ? 'bridge-col' : '',
    staticStyle: {
      "height": "2px",
      "float": "left",
      "width": "6.5%"
    }
  }), _vm._v(" "), _c('div', {
    ref: "016",
    class: _vm.bridgeList.includes(16) ? 'bridge-col' : '',
    staticStyle: {
      "height": "2px",
      "float": "left",
      "width": "7.65%"
    }
  }), _vm._v(" "), _c('div', {
    ref: "015",
    class: _vm.bridgeList.includes(15) ? 'bridge-col' : '',
    staticStyle: {
      "height": "2px",
      "float": "left",
      "width": "5.5%"
    }
  }), _vm._v(" "), _c('div', {
    ref: "014",
    class: _vm.bridgeList.includes(14) ? 'bridge-col' : '',
    staticStyle: {
      "height": "2px",
      "float": "left",
      "width": "5.25%"
    }
  }), _vm._v(" "), _c('div', {
    ref: "013",
    class: _vm.bridgeList.includes(13) ? 'bridge-col' : '',
    staticStyle: {
      "height": "2px",
      "float": "left",
      "width": "6.25%"
    }
  }), _vm._v(" "), _c('div', {
    ref: "012",
    class: _vm.bridgeList.includes(12) ? 'bridge-col' : '',
    staticStyle: {
      "height": "2px",
      "float": "left",
      "width": "5%"
    }
  }), _vm._v(" "), _c('div', {
    ref: "011",
    class: _vm.bridgeList.includes(11) ? 'bridge-col' : '',
    staticStyle: {
      "height": "2px",
      "float": "left",
      "width": "7%"
    }
  }), _vm._v(" "), _c('div', {
    ref: "021",
    class: _vm.bridgeList.includes(21) ? 'bridge-col' : '',
    staticStyle: {
      "height": "2px",
      "float": "left",
      "width": "7.5%"
    }
  }), _vm._v(" "), _c('div', {
    ref: "022",
    class: _vm.bridgeList.includes(22) ? 'bridge-col' : '',
    staticStyle: {
      "height": "2px",
      "float": "left",
      "width": "4.75%"
    }
  }), _vm._v(" "), _c('div', {
    ref: "023",
    class: _vm.bridgeList.includes(23) ? 'bridge-col' : '',
    staticStyle: {
      "height": "2px",
      "float": "left",
      "width": "6.25%"
    }
  }), _vm._v(" "), _c('div', {
    ref: "024",
    class: _vm.bridgeList.includes(24) ? 'bridge-col' : '',
    staticStyle: {
      "height": "2px",
      "float": "left",
      "width": "5.5%"
    }
  }), _vm._v(" "), _c('div', {
    ref: "025",
    class: _vm.bridgeList.includes(25) ? 'bridge-col' : '',
    staticStyle: {
      "height": "2px",
      "float": "left",
      "width": "5.25%"
    }
  }), _vm._v(" "), _c('div', {
    ref: "026",
    class: _vm.bridgeList.includes(26) ? 'bridge-col' : '',
    staticStyle: {
      "height": "2px",
      "float": "left",
      "width": "7.5%"
    }
  }), _vm._v(" "), _c('div', {
    ref: "027",
    class: _vm.bridgeList.includes(27) ? 'bridge-col' : '',
    staticStyle: {
      "height": "2px",
      "float": "left",
      "width": "7%"
    }
  }), _vm._v(" "), _c('div', {
    ref: "028",
    class: _vm.bridgeList.includes(28) ? 'bridge-col' : '',
    staticStyle: {
      "height": "2px",
      "float": "left",
      "width": "6.25%"
    }
  })]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "0 30px",
      "font-size": "18px"
    }
  }, [_vm._v("R")]), _vm._v(" "), _c('td', [_c('table', {
    class: _vm.isShow ? 'tooth-table-show' : 'tooth-table',
    attrs: {
      "cellspace": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "float": "right",
      "padding-bottom": "5px",
      "padding-right": "5px",
      "white-space": "nowrap"
    }
  }, [_c('img', {
    ref: "18",
    class: _vm.bridgeList.includes(18) ? 'tooth-bridge' : 'tooth-single',
    attrs: {
      "id": "18",
      "src": '/static/images/tooth/18' + (_vm.activeList.includes(18) ? '_active' : '') + '.png'
    },
    on: {
      "click": function($event) {
        return _vm.shiftClickTooth($event)
      }
    }
  }), _vm._v(" "), _c('img', {
    ref: "17",
    class: _vm.bridgeList.includes(17) ? 'tooth-bridge' : 'tooth-single',
    attrs: {
      "id": "17",
      "src": '/static/images/tooth/17' + (_vm.activeList.includes(17) ? '_active' : '') + '.png'
    },
    on: {
      "click": function($event) {
        return _vm.shiftClickTooth($event)
      }
    }
  }), _vm._v(" "), _c('img', {
    ref: "16",
    class: _vm.bridgeList.includes(16) ? 'tooth-bridge' : 'tooth-single',
    attrs: {
      "id": "16",
      "src": '/static/images/tooth/16' + (_vm.activeList.includes(16) ? '_active' : '') + '.png'
    },
    on: {
      "click": function($event) {
        return _vm.shiftClickTooth($event)
      }
    }
  }), _vm._v(" "), _c('img', {
    ref: "15",
    class: _vm.bridgeList.includes(15) ? 'tooth-bridge' : 'tooth-single',
    attrs: {
      "id": "15",
      "src": '/static/images/tooth/15' + (_vm.activeList.includes(15) ? '_active' : '') + '.png'
    },
    on: {
      "click": function($event) {
        return _vm.shiftClickTooth($event)
      }
    }
  }), _vm._v(" "), _c('img', {
    ref: "14",
    class: _vm.bridgeList.includes(14) ? 'tooth-bridge' : 'tooth-single',
    attrs: {
      "id": "14",
      "src": '/static/images/tooth/14' + (_vm.activeList.includes(14) ? '_active' : '') + '.png'
    },
    on: {
      "click": function($event) {
        return _vm.shiftClickTooth($event)
      }
    }
  }), _vm._v(" "), _c('img', {
    ref: "13",
    class: _vm.bridgeList.includes(13) ? 'tooth-bridge' : 'tooth-single',
    attrs: {
      "id": "13",
      "src": '/static/images/tooth/13' + (_vm.activeList.includes(13) ? '_active' : '') + '.png'
    },
    on: {
      "click": function($event) {
        return _vm.shiftClickTooth($event)
      }
    }
  }), _vm._v(" "), _c('img', {
    ref: "12",
    class: _vm.bridgeList.includes(12) ? 'tooth-bridge' : 'tooth-single',
    attrs: {
      "id": "12",
      "src": '/static/images/tooth/12' + (_vm.activeList.includes(12) ? '_active' : '') + '.png'
    },
    on: {
      "click": function($event) {
        return _vm.shiftClickTooth($event)
      }
    }
  }), _vm._v(" "), _c('img', {
    ref: "11",
    class: _vm.bridgeList.includes(11) ? 'tooth-bridge' : 'tooth-single',
    attrs: {
      "id": "11",
      "src": '/static/images/tooth/11' + (_vm.activeList.includes(11) ? '_active' : '') + '.png'
    },
    on: {
      "click": function($event) {
        return _vm.shiftClickTooth($event)
      }
    }
  })]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "1px",
      "background": "#808080"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "float": "left",
      "padding-bottom": "5px",
      "padding-left": "5px",
      "white-space": "nowrap"
    }
  }, [_c('img', {
    ref: "21",
    class: _vm.bridgeList.includes(21) ? 'tooth-bridge' : 'tooth-single',
    attrs: {
      "id": "21",
      "src": '/static/images/tooth/21' + (_vm.activeList.includes(21) ? '_active' : '') + '.png'
    },
    on: {
      "click": function($event) {
        return _vm.shiftClickTooth($event)
      }
    }
  }), _vm._v(" "), _c('img', {
    ref: "22",
    class: _vm.bridgeList.includes(22) ? 'tooth-bridge' : 'tooth-single',
    attrs: {
      "id": "22",
      "src": '/static/images/tooth/22' + (_vm.activeList.includes(22) ? '_active' : '') + '.png'
    },
    on: {
      "click": function($event) {
        return _vm.shiftClickTooth($event)
      }
    }
  }), _vm._v(" "), _c('img', {
    ref: "23",
    class: _vm.bridgeList.includes(23) ? 'tooth-bridge' : 'tooth-single',
    attrs: {
      "id": "23",
      "src": '/static/images/tooth/23' + (_vm.activeList.includes(23) ? '_active' : '') + '.png'
    },
    on: {
      "click": function($event) {
        return _vm.shiftClickTooth($event)
      }
    }
  }), _vm._v(" "), _c('img', {
    ref: "24",
    class: _vm.bridgeList.includes(24) ? 'tooth-bridge' : 'tooth-single',
    attrs: {
      "id": "24",
      "src": '/static/images/tooth/24' + (_vm.activeList.includes(24) ? '_active' : '') + '.png'
    },
    on: {
      "click": function($event) {
        return _vm.shiftClickTooth($event)
      }
    }
  }), _vm._v(" "), _c('img', {
    ref: "25",
    class: _vm.bridgeList.includes(25) ? 'tooth-bridge' : 'tooth-single',
    attrs: {
      "id": "25",
      "src": '/static/images/tooth/25' + (_vm.activeList.includes(25) ? '_active' : '') + '.png'
    },
    on: {
      "click": function($event) {
        return _vm.shiftClickTooth($event)
      }
    }
  }), _vm._v(" "), _c('img', {
    ref: "26",
    class: _vm.bridgeList.includes(26) ? 'tooth-bridge' : 'tooth-single',
    attrs: {
      "id": "26",
      "src": '/static/images/tooth/26' + (_vm.activeList.includes(26) ? '_active' : '') + '.png'
    },
    on: {
      "click": function($event) {
        return _vm.shiftClickTooth($event)
      }
    }
  }), _vm._v(" "), _c('img', {
    ref: "27",
    class: _vm.bridgeList.includes(27) ? 'tooth-bridge' : 'tooth-single',
    attrs: {
      "id": "27",
      "src": '/static/images/tooth/27' + (_vm.activeList.includes(27) ? '_active' : '') + '.png'
    },
    on: {
      "click": function($event) {
        return _vm.shiftClickTooth($event)
      }
    }
  }), _vm._v(" "), _c('img', {
    ref: "28",
    class: _vm.bridgeList.includes(28) ? 'tooth-bridge' : 'tooth-single',
    attrs: {
      "id": "28",
      "src": '/static/images/tooth/28' + (_vm.activeList.includes(28) ? '_active' : '') + '.png'
    },
    on: {
      "click": function($event) {
        return _vm.shiftClickTooth($event)
      }
    }
  })])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "float": "right",
      "padding-top": "5px",
      "padding-right": "5px",
      "white-space": "nowrap"
    }
  }, [_c('img', {
    ref: "48",
    class: _vm.bridgeList.includes(48) ? 'tooth-bridge' : 'tooth-single',
    attrs: {
      "id": "48",
      "src": '/static/images/tooth/48' + (_vm.activeList.includes(48) ? '_active' : '') + '.png'
    },
    on: {
      "click": function($event) {
        return _vm.shiftClickTooth($event)
      }
    }
  }), _vm._v(" "), _c('img', {
    ref: "47",
    class: _vm.bridgeList.includes(47) ? 'tooth-bridge' : 'tooth-single',
    attrs: {
      "id": "47",
      "src": '/static/images/tooth/47' + (_vm.activeList.includes(47) ? '_active' : '') + '.png'
    },
    on: {
      "click": function($event) {
        return _vm.shiftClickTooth($event)
      }
    }
  }), _vm._v(" "), _c('img', {
    ref: "46",
    class: _vm.bridgeList.includes(46) ? 'tooth-bridge' : 'tooth-single',
    attrs: {
      "id": "46",
      "src": '/static/images/tooth/46' + (_vm.activeList.includes(46) ? '_active' : '') + '.png'
    },
    on: {
      "click": function($event) {
        return _vm.shiftClickTooth($event)
      }
    }
  }), _vm._v(" "), _c('img', {
    ref: "45",
    class: _vm.bridgeList.includes(45) ? 'tooth-bridge' : 'tooth-single',
    attrs: {
      "id": "45",
      "src": '/static/images/tooth/45' + (_vm.activeList.includes(45) ? '_active' : '') + '.png'
    },
    on: {
      "click": function($event) {
        return _vm.shiftClickTooth($event)
      }
    }
  }), _vm._v(" "), _c('img', {
    ref: "44",
    class: _vm.bridgeList.includes(44) ? 'tooth-bridge' : 'tooth-single',
    attrs: {
      "id": "44",
      "src": '/static/images/tooth/44' + (_vm.activeList.includes(44) ? '_active' : '') + '.png'
    },
    on: {
      "click": function($event) {
        return _vm.shiftClickTooth($event)
      }
    }
  }), _vm._v(" "), _c('img', {
    ref: "43",
    class: _vm.bridgeList.includes(43) ? 'tooth-bridge' : 'tooth-single',
    attrs: {
      "id": "43",
      "src": '/static/images/tooth/43' + (_vm.activeList.includes(43) ? '_active' : '') + '.png'
    },
    on: {
      "click": function($event) {
        return _vm.shiftClickTooth($event)
      }
    }
  }), _vm._v(" "), _c('img', {
    ref: "42",
    class: _vm.bridgeList.includes(42) ? 'tooth-bridge' : 'tooth-single',
    attrs: {
      "id": "42",
      "src": '/static/images/tooth/42' + (_vm.activeList.includes(42) ? '_active' : '') + '.png'
    },
    on: {
      "click": function($event) {
        return _vm.shiftClickTooth($event)
      }
    }
  }), _vm._v(" "), _c('img', {
    ref: "41",
    class: _vm.bridgeList.includes(41) ? 'tooth-bridge' : 'tooth-single',
    attrs: {
      "id": "41",
      "src": '/static/images/tooth/41' + (_vm.activeList.includes(41) ? '_active' : '') + '.png'
    },
    on: {
      "click": function($event) {
        return _vm.shiftClickTooth($event)
      }
    }
  })]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "1px",
      "background": "#808080"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "float": "left",
      "padding-top": "5px",
      "padding-left": "5px",
      "white-space": "nowrap"
    }
  }, [_c('img', {
    ref: "31",
    class: _vm.bridgeList.includes(31) ? 'tooth-bridge' : 'tooth-single',
    attrs: {
      "id": "31",
      "src": '/static/images/tooth/31' + (_vm.activeList.includes(31) ? '_active' : '') + '.png'
    },
    on: {
      "click": function($event) {
        return _vm.shiftClickTooth($event)
      }
    }
  }), _vm._v(" "), _c('img', {
    ref: "32",
    class: _vm.bridgeList.includes(32) ? 'tooth-bridge' : 'tooth-single',
    attrs: {
      "id": "32",
      "src": '/static/images/tooth/32' + (_vm.activeList.includes(32) ? '_active' : '') + '.png'
    },
    on: {
      "click": function($event) {
        return _vm.shiftClickTooth($event)
      }
    }
  }), _vm._v(" "), _c('img', {
    ref: "33",
    class: _vm.bridgeList.includes(33) ? 'tooth-bridge' : 'tooth-single',
    attrs: {
      "id": "33",
      "src": '/static/images/tooth/33' + (_vm.activeList.includes(33) ? '_active' : '') + '.png'
    },
    on: {
      "click": function($event) {
        return _vm.shiftClickTooth($event)
      }
    }
  }), _vm._v(" "), _c('img', {
    ref: "34",
    class: _vm.bridgeList.includes(34) ? 'tooth-bridge' : 'tooth-single',
    attrs: {
      "id": "34",
      "src": '/static/images/tooth/34' + (_vm.activeList.includes(34) ? '_active' : '') + '.png'
    },
    on: {
      "click": function($event) {
        return _vm.shiftClickTooth($event)
      }
    }
  }), _vm._v(" "), _c('img', {
    ref: "35",
    class: _vm.bridgeList.includes(35) ? 'tooth-bridge' : 'tooth-single',
    attrs: {
      "id": "35",
      "src": '/static/images/tooth/35' + (_vm.activeList.includes(35) ? '_active' : '') + '.png'
    },
    on: {
      "click": function($event) {
        return _vm.shiftClickTooth($event)
      }
    }
  }), _vm._v(" "), _c('img', {
    ref: "36",
    class: _vm.bridgeList.includes(36) ? 'tooth-bridge' : 'tooth-single',
    attrs: {
      "id": "36",
      "src": '/static/images/tooth/36' + (_vm.activeList.includes(36) ? '_active' : '') + '.png'
    },
    on: {
      "click": function($event) {
        return _vm.shiftClickTooth($event)
      }
    }
  }), _vm._v(" "), _c('img', {
    ref: "37",
    class: _vm.bridgeList.includes(37) ? 'tooth-bridge' : 'tooth-single',
    attrs: {
      "id": "37",
      "src": '/static/images/tooth/37' + (_vm.activeList.includes(37) ? '_active' : '') + '.png'
    },
    on: {
      "click": function($event) {
        return _vm.shiftClickTooth($event)
      }
    }
  }), _vm._v(" "), _c('img', {
    ref: "38",
    class: _vm.bridgeList.includes(38) ? 'tooth-bridge' : 'tooth-single',
    attrs: {
      "id": "38",
      "src": '/static/images/tooth/38' + (_vm.activeList.includes(38) ? '_active' : '') + '.png'
    },
    on: {
      "click": function($event) {
        return _vm.shiftClickTooth($event)
      }
    }
  })])])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "0 30px",
      "font-size": "18px"
    }
  }, [_vm._v("L")])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "10px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "10px",
      "width": "3.55%",
      "float": "left"
    },
    attrs: {
      "id": "null"
    }
  }), _vm._v(" "), _c('div', {
    ref: "048",
    class: _vm.bridgeList.includes(48) ? 'bridge-col' : '',
    staticStyle: {
      "height": "2px",
      "width": "6.4%",
      "float": "left"
    }
  }), _vm._v(" "), _c('div', {
    ref: "047",
    class: _vm.bridgeList.includes(47) ? 'bridge-col' : '',
    staticStyle: {
      "height": "2px",
      "width": "7.3%",
      "float": "left"
    }
  }), _vm._v(" "), _c('div', {
    ref: "046",
    class: _vm.bridgeList.includes(46) ? 'bridge-col' : '',
    staticStyle: {
      "height": "2px",
      "width": "8.2%",
      "float": "left"
    }
  }), _vm._v(" "), _c('div', {
    ref: "045",
    class: _vm.bridgeList.includes(45) ? 'bridge-col' : '',
    staticStyle: {
      "height": "2px",
      "width": "5%",
      "float": "left"
    }
  }), _vm._v(" "), _c('div', {
    ref: "044",
    class: _vm.bridgeList.includes(44) ? 'bridge-col' : '',
    staticStyle: {
      "height": "2px",
      "width": "5%",
      "float": "left"
    }
  }), _vm._v(" "), _c('div', {
    ref: "043",
    class: _vm.bridgeList.includes(43) ? 'bridge-col' : '',
    staticStyle: {
      "height": "2px",
      "width": "5.4%",
      "float": "left"
    }
  }), _vm._v(" "), _c('div', {
    ref: "042",
    class: _vm.bridgeList.includes(42) ? 'bridge-col' : '',
    staticStyle: {
      "height": "2px",
      "width": "4.3%",
      "float": "left"
    }
  }), _vm._v(" "), _c('div', {
    ref: "041",
    class: _vm.bridgeList.includes(41) ? 'bridge-col' : '',
    staticStyle: {
      "height": "2px",
      "width": "4.75%",
      "float": "left"
    }
  }), _vm._v(" "), _c('div', {
    ref: "031",
    class: _vm.bridgeList.includes(31) ? 'bridge-col' : '',
    staticStyle: {
      "height": "2px",
      "width": "5%",
      "float": "left"
    }
  }), _vm._v(" "), _c('div', {
    ref: "032",
    class: _vm.bridgeList.includes(32) ? 'bridge-col' : '',
    staticStyle: {
      "height": "2px",
      "width": "4.3%",
      "float": "left"
    }
  }), _vm._v(" "), _c('div', {
    ref: "033",
    class: _vm.bridgeList.includes(33) ? 'bridge-col' : '',
    staticStyle: {
      "height": "2px",
      "width": "5.3%",
      "float": "left"
    }
  }), _vm._v(" "), _c('div', {
    ref: "034",
    class: _vm.bridgeList.includes(34) ? 'bridge-col' : '',
    staticStyle: {
      "height": "2px",
      "width": "5%",
      "float": "left"
    }
  }), _vm._v(" "), _c('div', {
    ref: "035",
    class: _vm.bridgeList.includes(35) ? 'bridge-col' : '',
    staticStyle: {
      "height": "2px",
      "width": "5.1%",
      "float": "left"
    }
  }), _vm._v(" "), _c('div', {
    ref: "036",
    class: _vm.bridgeList.includes(36) ? 'bridge-col' : '',
    staticStyle: {
      "height": "2px",
      "width": "8.2%",
      "float": "left"
    }
  }), _vm._v(" "), _c('div', {
    ref: "037",
    class: _vm.bridgeList.includes(37) ? 'bridge-col' : '',
    staticStyle: {
      "height": "2px",
      "width": "7.25%",
      "float": "left"
    }
  }), _vm._v(" "), _c('div', {
    ref: "038",
    class: _vm.bridgeList.includes(38) ? 'bridge-col' : '',
    staticStyle: {
      "height": "2px",
      "width": "6.4%",
      "float": "left"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "10px",
      "width": "3.55%",
      "float": "left"
    },
    attrs: {
      "id": "null"
    }
  })]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "10px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "10px",
      "width": "3.55%",
      "float": "left"
    },
    attrs: {
      "id": "null"
    }
  }), _vm._v(" "), (_vm.metalPlatForm.includes(48)) ? _c('div', {
    ref: "048",
    class: _vm.metalPlatForm.includes(48) ? 'bridge-col-add' : 'bridge-col-zero',
    staticStyle: {
      "height": "2px",
      "width": "6.4%",
      "float": "left"
    }
  }, [_c('i', {
    staticClass: "el-icon-s-help lab-cen"
  })]) : _c('div', {
    class: _vm.metalPlatForm2.includes(48) ? 'bridge-col-add' : 'bridge-col-zero',
    staticStyle: {
      "height": "2px",
      "width": "6.4%",
      "float": "left"
    }
  }, [_c('i', {
    staticClass: "el-icon-s-help lab-cen porcelain"
  })]), _vm._v(" "), (_vm.metalPlatForm.includes(47)) ? _c('div', {
    class: _vm.metalPlatForm.includes(47) ? 'bridge-col-add' : 'bridge-col-zero',
    staticStyle: {
      "height": "2px",
      "width": "7.3%",
      "float": "left"
    }
  }, [_c('i', {
    staticClass: "el-icon-s-help lab-cen"
  })]) : _c('div', {
    class: _vm.metalPlatForm2.includes(47) ? 'bridge-col-add' : 'bridge-col-zero',
    staticStyle: {
      "height": "2px",
      "width": "7.3%",
      "float": "left"
    }
  }, [_c('i', {
    staticClass: "el-icon-s-help lab-cen porcelain"
  })]), _vm._v(" "), (_vm.metalPlatForm.includes(46)) ? _c('div', {
    class: _vm.metalPlatForm.includes(46) ? 'bridge-col-add' : 'bridge-col-zero',
    staticStyle: {
      "height": "2px",
      "width": "8.2%",
      "float": "left"
    }
  }, [_c('i', {
    staticClass: "el-icon-s-help lab-cen"
  })]) : _c('div', {
    class: _vm.metalPlatForm2.includes(46) ? 'bridge-col-add' : 'bridge-col-zero',
    staticStyle: {
      "height": "2px",
      "width": "8.2%",
      "float": "left"
    }
  }, [_c('i', {
    staticClass: "el-icon-s-help lab-cen porcelain"
  })]), _vm._v(" "), (_vm.metalPlatForm.includes(45)) ? _c('div', {
    class: _vm.metalPlatForm.includes(45) ? 'bridge-col-add' : 'bridge-col-zero',
    staticStyle: {
      "height": "2px",
      "width": "5%",
      "float": "left"
    }
  }, [_c('i', {
    staticClass: "el-icon-s-help lab-cen",
    staticStyle: {
      "margin-left": "23%"
    }
  })]) : _c('div', {
    class: _vm.metalPlatForm2.includes(45) ? 'bridge-col-add' : 'bridge-col-zero',
    staticStyle: {
      "height": "2px",
      "width": "5%",
      "float": "left"
    }
  }, [_c('i', {
    staticClass: "el-icon-s-help lab-cen porcelain",
    staticStyle: {
      "margin-left": "23%"
    }
  })]), _vm._v(" "), (_vm.metalPlatForm.includes(44)) ? _c('div', {
    class: _vm.metalPlatForm.includes(44) ? 'bridge-col-add' : 'bridge-col-zero',
    staticStyle: {
      "height": "2px",
      "width": "5%",
      "float": "left"
    }
  }, [_c('i', {
    staticClass: "el-icon-s-help lab-cen"
  })]) : _c('div', {
    class: _vm.metalPlatForm2.includes(44) ? 'bridge-col-add' : 'bridge-col-zero',
    staticStyle: {
      "height": "2px",
      "width": "5%",
      "float": "left"
    }
  }, [_c('i', {
    staticClass: "el-icon-s-help lab-cen porcelain"
  })]), _vm._v(" "), (_vm.metalPlatForm.includes(43)) ? _c('div', {
    ref: "043",
    class: _vm.metalPlatForm.includes(43) ? 'bridge-col-add' : 'bridge-col-zero',
    staticStyle: {
      "height": "2px",
      "width": "5.4%",
      "float": "left"
    }
  }, [_c('i', {
    staticClass: "el-icon-s-help lab-cen"
  })]) : _c('div', {
    class: _vm.metalPlatForm2.includes(43) ? 'bridge-col-add' : 'bridge-col-zero',
    staticStyle: {
      "height": "2px",
      "width": "5.4%",
      "float": "left"
    }
  }, [_c('i', {
    staticClass: "el-icon-s-help lab-cen porcelain"
  })]), _vm._v(" "), (_vm.metalPlatForm.includes(42)) ? _c('div', {
    class: _vm.metalPlatForm.includes(42) ? 'bridge-col-add' : 'bridge-col-zero',
    staticStyle: {
      "height": "2px",
      "width": "4.3%",
      "float": "left"
    }
  }, [_c('i', {
    staticClass: "el-icon-s-help lab-cen"
  })]) : _c('div', {
    class: _vm.metalPlatForm2.includes(42) ? 'bridge-col-add' : 'bridge-col-zero',
    staticStyle: {
      "height": "2px",
      "width": "4.3%",
      "float": "left"
    }
  }, [_c('i', {
    staticClass: "el-icon-s-help lab-cen porcelain"
  })]), _vm._v(" "), (_vm.metalPlatForm.includes(41)) ? _c('div', {
    class: _vm.metalPlatForm.includes(41) ? 'bridge-col-add' : 'bridge-col-zero',
    staticStyle: {
      "height": "2px",
      "width": "4.75%",
      "float": "left"
    }
  }, [_c('i', {
    staticClass: "el-icon-s-help lab-cen",
    staticStyle: {
      "margin-left": "30%"
    }
  })]) : _c('div', {
    class: _vm.metalPlatForm2.includes(41) ? 'bridge-col-add' : 'bridge-col-zero',
    staticStyle: {
      "height": "2px",
      "width": "4.75%",
      "float": "left"
    }
  }, [_c('i', {
    staticClass: "el-icon-s-help lab-cen porcelain"
  })]), _vm._v(" "), (_vm.metalPlatForm.includes(31)) ? _c('div', {
    class: _vm.metalPlatForm.includes(31) ? 'bridge-col-add' : 'bridge-col-zero',
    staticStyle: {
      "height": "2px",
      "width": "5%",
      "float": "left"
    }
  }, [_c('i', {
    staticClass: "el-icon-s-help lab-cen",
    staticStyle: {
      "margin-left": "35%"
    }
  })]) : _c('div', {
    class: _vm.metalPlatForm2.includes(31) ? 'bridge-col-add' : 'bridge-col-zero',
    staticStyle: {
      "height": "2px",
      "width": "5%",
      "float": "left"
    }
  }, [_c('i', {
    staticClass: "el-icon-s-help lab-cen porcelain"
  })]), _vm._v(" "), (_vm.metalPlatForm.includes(32)) ? _c('div', {
    class: _vm.metalPlatForm.includes(32) ? 'bridge-col-add' : 'bridge-col-zero',
    staticStyle: {
      "height": "2px",
      "width": "4.3%",
      "float": "left"
    }
  }, [_c('i', {
    staticClass: "el-icon-s-help lab-cen"
  })]) : _c('div', {
    class: _vm.metalPlatForm2.includes(32) ? 'bridge-col-add' : 'bridge-col-zero',
    staticStyle: {
      "height": "2px",
      "width": "4.3%",
      "float": "left"
    }
  }, [_c('i', {
    staticClass: "el-icon-s-help lab-cen porcelain"
  })]), _vm._v(" "), (_vm.metalPlatForm.includes(33)) ? _c('div', {
    class: _vm.metalPlatForm.includes(33) ? 'bridge-col-add' : 'bridge-col-zero',
    staticStyle: {
      "height": "2px",
      "width": "5.3%",
      "float": "left"
    }
  }, [_c('i', {
    staticClass: "el-icon-s-help lab-cen"
  })]) : _c('div', {
    class: _vm.metalPlatForm2.includes(33) ? 'bridge-col-add' : 'bridge-col-zero',
    staticStyle: {
      "height": "2px",
      "width": "5.3%",
      "float": "left"
    }
  }, [_c('i', {
    staticClass: "el-icon-s-help lab-cen porcelain"
  })]), _vm._v(" "), (_vm.metalPlatForm.includes(34)) ? _c('div', {
    class: _vm.metalPlatForm.includes(34) ? 'bridge-col-add' : 'bridge-col-zero',
    staticStyle: {
      "height": "2px",
      "width": "5%",
      "float": "left"
    }
  }, [_c('i', {
    staticClass: "el-icon-s-help lab-cen"
  })]) : _c('div', {
    class: _vm.metalPlatForm2.includes(34) ? 'bridge-col-add' : 'bridge-col-zero',
    staticStyle: {
      "height": "2px",
      "width": "5%",
      "float": "left"
    }
  }, [_c('i', {
    staticClass: "el-icon-s-help lab-cen porcelain"
  })]), _vm._v(" "), (_vm.metalPlatForm.includes(35)) ? _c('div', {
    class: _vm.metalPlatForm.includes(35) ? 'bridge-col-add' : 'bridge-col-zero',
    staticStyle: {
      "height": "2px",
      "width": "5.1%",
      "float": "left"
    }
  }, [_c('i', {
    staticClass: "el-icon-s-help lab-cen"
  })]) : _c('div', {
    class: _vm.metalPlatForm2.includes(35) ? 'bridge-col-add' : 'bridge-col-zero',
    staticStyle: {
      "height": "2px",
      "width": "5.1%",
      "float": "left"
    }
  }, [_c('i', {
    staticClass: "el-icon-s-help lab-cen porcelain"
  })]), _vm._v(" "), (_vm.metalPlatForm.includes(36)) ? _c('div', {
    class: _vm.metalPlatForm.includes(36) ? 'bridge-col-add' : 'bridge-col-zero',
    staticStyle: {
      "height": "2px",
      "width": "8.2%",
      "float": "left"
    }
  }, [_c('i', {
    staticClass: "el-icon-s-help lab-cen"
  })]) : _c('div', {
    class: _vm.metalPlatForm2.includes(36) ? 'bridge-col-add' : 'bridge-col-zero',
    staticStyle: {
      "height": "2px",
      "width": "8.2%",
      "float": "left"
    }
  }, [_c('i', {
    staticClass: "el-icon-s-help lab-cen porcelain"
  })]), _vm._v(" "), (_vm.metalPlatForm.includes(37)) ? _c('div', {
    class: _vm.metalPlatForm.includes(37) ? 'bridge-col-add' : 'bridge-col-zero',
    staticStyle: {
      "height": "2px",
      "width": "7.25%",
      "float": "left"
    }
  }, [_c('i', {
    staticClass: "el-icon-s-help lab-cen"
  })]) : _c('div', {
    class: _vm.metalPlatForm2.includes(37) ? 'bridge-col-add' : 'bridge-col-zero',
    staticStyle: {
      "height": "2px",
      "width": "7.25%",
      "float": "left"
    }
  }, [_c('i', {
    staticClass: "el-icon-s-help lab-cen porcelain"
  })]), _vm._v(" "), (_vm.metalPlatForm.includes(38)) ? _c('div', {
    class: _vm.metalPlatForm.includes(38) ? 'bridge-col-add' : 'bridge-col-zero',
    staticStyle: {
      "height": "2px",
      "width": "6.4%",
      "float": "left"
    }
  }, [_c('i', {
    staticClass: "el-icon-s-help lab-cen"
  })]) : _c('div', {
    class: _vm.metalPlatForm2.includes(38) ? 'bridge-col-add' : 'bridge-col-zero',
    staticStyle: {
      "height": "2px",
      "width": "6.4%",
      "float": "left"
    }
  }, [_c('i', {
    staticClass: "el-icon-s-help lab-cen porcelain"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "10px",
      "width": "3.55%",
      "float": "left"
    },
    attrs: {
      "id": "null"
    }
  })]), _vm._v(" "), _c('td')])])]), _vm._v(" "), (!_vm.isShow) ? _c('div', {
    staticClass: "button-wrap",
    staticStyle: {
      "margin-top": "-5px"
    }
  }, [_c('div', {
    staticClass: "button-add",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [(_vm.isBridge && _vm.tempList.length > 1) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini",
      "round": "",
      "plain": ""
    },
    on: {
      "click": _vm.addBridge
    }
  }, [_vm._v("添加连桥\n        ")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    staticClass: "btn-pos",
    attrs: {
      "type": "primary",
      "size": "mini",
      "round": "",
      "plain": ""
    },
    on: {
      "click": _vm.selectAll
    }
  }, [_vm._v("全部选择")])], 1), _vm._v(" "), _c('div', {
    staticClass: "button-clear",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [(_vm.isBridge && _vm.activeBridgeList.length > 0) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini",
      "round": "",
      "plain": ""
    },
    on: {
      "click": _vm.resetBridge
    }
  }, [_vm._v("清除连桥")]) : _vm._e(), _vm._v(" "), (_vm.activeSingleList.length > 0 || _vm.metalPlatForm.length > 0 || _vm.metalPlatForm2.length > 0) ? _c('el-button', {
    staticClass: "btn-pos",
    attrs: {
      "type": "primary",
      "size": "mini",
      "round": "",
      "plain": ""
    },
    on: {
      "click": _vm.resetSingle
    }
  }, [_vm._v("全部清除")]) : _vm._e()], 1)]) : _vm._e()]), _vm._v(" "), _c('div')])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticStyle: {
      "height": "1px",
      "background": "#808080"
    },
    attrs: {
      "colspan": "167"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-be113e76","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/YTooth.vue
// module id = 689
// module chunks = 0